<div ngClass="bl-stores" [ngClass]="{ 'stores-es': isLangEs }">
    <a (click)="goToStore('ios')"><img src="../assets/images/about/en/app-store.svg" alt="app-store"></a>&nbsp;
    <a (click)="goToStore('android')"><img src="../assets/images/about/en/play-store.svg" alt="play-store"></a>
</div>